"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ListItemSecondaryAction = _interopRequireDefault(require("@mui/material/ListItemSecondaryAction"));
var _ChevronForward = _interopRequireDefault(require("@quintoandar/cozy-icons/ChevronForward"));
var _Box = _interopRequireDefault(require("../../Box"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var ListItemNavigationIcon = function ListItemNavigationIcon(_ref) {
  var color = _ref.color;
  return /*#__PURE__*/_react["default"].createElement(_ListItemSecondaryAction["default"], null, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    display: "flex"
  }, /*#__PURE__*/_react["default"].createElement(_ChevronForward["default"], {
    color: color
  })));
};
ListItemNavigationIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  color: _propTypes["default"].string.isRequired
} : {};
var _default = exports["default"] = ListItemNavigationIcon;